import { Brand, PageHeader } from '@patternfly/react-core';
import * as React from 'react';
import { useMediaQuery } from 'react-responsive';
import Navigation from './Navigation';
import Toolbar from './Toolbar';
import './Header.css';

function Header({ onNavToggle }: { onNavToggle: () => void }) {
  const laptopOrBigger = useMediaQuery({ minWidth: 1400 });
  return (
    <PageHeader
      logo={(
        <div className="header-logo">
          <Brand src="/assets/images/Logotipo_SITE_kronex-21.png" alt="Site Kronex" style={{ width: '50%' }} />
        </div>
      )}
      logoProps={{
        rel: 'noopener noreferrer',
      }}
      headerTools={<Toolbar />}
      topNav={laptopOrBigger && <Navigation variant="horizontal" />}
      showNavToggle={!laptopOrBigger}
      onNavToggle={onNavToggle}
      style={{
        backgroundColor: '#355d91', // transparent background for background image
      }}
    />
  );
}

export default Header;
